(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["han-photo-hero"] && !Shopify.designMode) return;
  try {
    
function initialiseHanHeroes(root=document){
  [...(root.matches?.('[data-han-hero]')?[root]:[]),...root.querySelectorAll('[data-han-hero]')].forEach(hero=>{
    if(hero.dataset.ready)return;hero.dataset.ready='true';
    const controller=new AbortController(),signal=controller.signal;
    const fine=matchMedia('(hover:hover) and (pointer:fine)');
    const group=hero.querySelector('[role=tablist]'),tabs=[...group.querySelectorAll('[role=tab]')];
    const panels=tabs.map(t=>hero.querySelector('#'+CSS.escape(t.getAttribute('aria-controls'))));
    let selected=tabs.findIndex(t=>t.getAttribute('aria-selected')==='true'),hovered=null,focused=null;
    const indicator=document.createElement('span');indicator.className='han-hero-tabs__indicator';indicator.setAttribute('aria-hidden','true');group.append(indicator);group.dataset.hanTabsMotion='true';
    function place(){const target=hovered||focused||tabs[selected];tabs.forEach(t=>t.toggleAttribute('data-han-tab-highlight',t===target));group.dataset.hanTabState=target===tabs[selected]?'selected':'preview';group.style.setProperty('--han-tab-x',target.offsetLeft+'px');group.style.setProperty('--han-tab-y',target.offsetTop+'px');group.style.setProperty('--han-tab-width',target.offsetWidth+'px');group.style.setProperty('--han-tab-height',target.offsetHeight+'px')}
    group.style.setProperty('z-index',String(panels.length+1),'important');
    const reduced=matchMedia('(prefers-reduced-motion: reduce)');
    let transition=null;
    panels.forEach(panel=>{const img=panel.querySelector('img');if(img){img.loading='eager';img.decode?.().catch(()=>{})}});
    function settle(index){
      panels.forEach((panel,i)=>{panel.hidden=i!==index;panel.inert=i!==index;panel.setAttribute('aria-hidden',String(i!==index));panel.style.opacity='';panel.style.zIndex=''});
    }
    function select(index){
      if(index===selected)return;
      const incoming=panels[index];
      const start=incoming.hidden?0:Number(getComputedStyle(incoming).opacity);
      if(transition){
        const target=transition.effect.target;
        const opacity=getComputedStyle(target).opacity;
        transition.onfinish=null;
        transition.cancel();
        target.style.opacity=opacity;
        transition=null;
      }
      selected=index;
      panels.forEach((panel,i)=>{panel.inert=i!==index;panel.setAttribute('aria-hidden',String(i!==index))});
      incoming.hidden=false;
      panels.filter(panel=>panel!==incoming&&!panel.hidden).sort((a,b)=>Number(b.style.zIndex)-Number(a.style.zIndex)).forEach((panel,i)=>panel.style.zIndex=String(panels.length-i-1));
      incoming.style.zIndex=String(panels.length);
      incoming.style.opacity='1';
      tabs.forEach((t,i)=>{t.setAttribute('aria-selected',String(i===index));t.tabIndex=i===index?0:-1});place();
      if(reduced.matches){settle(index);return}
      transition=incoming.animate([{opacity:start},{opacity:1}],{duration:340,easing:'cubic-bezier(.16,1,.3,1)'});
      transition.onfinish=()=>{transition=null;settle(index)};
    }
    tabs.forEach((tab,i)=>{
      tab.addEventListener('click',()=>select(i),{signal});
      tab.addEventListener('pointerenter',event=>{if(fine.matches&&event.pointerType!=='touch'){hovered=tab;select(i);place()}},{signal});
      tab.addEventListener('keydown',event=>{let j;if(event.key==='ArrowRight')j=(i+1)%tabs.length;if(event.key==='ArrowLeft')j=(i+tabs.length-1)%tabs.length;if(event.key==='Home')j=0;if(event.key==='End')j=tabs.length-1;if(j!==undefined){event.preventDefault();select(j);tabs[j].focus()}},{signal});
    });
    group.addEventListener('pointerleave',()=>{hovered=null;focused=null;place()},{signal});
    group.addEventListener('pointerdown',event=>{if(event.pointerType==='touch'){hovered=null;focused=null;place()}},{signal});
    group.addEventListener('focusin',event=>{if(event.target.matches('[role=tab]:focus-visible')){focused=event.target;hovered=null;place()}},{signal});
    group.addEventListener('focusout',()=>{focused=null;place()},{signal});
    const syncSize=()=>{hero.style.setProperty('--hero-tabs-height',group.getBoundingClientRect().height+'px');place()};const resize=new ResizeObserver(syncSize);resize.observe(group);document.fonts.ready.then(()=>{if(hero.isConnected)place()});place();const frame=requestAnimationFrame(()=>group.dataset.hanTabsReady='true');
    document.addEventListener('shopify:section:unload',event=>{if(!event.target.contains(hero))return;resize.disconnect();if(transition){transition.onfinish=null;transition.cancel()}cancelAnimationFrame(frame);controller.abort();indicator.remove();delete hero.dataset.ready;delete group.dataset.hanTabsMotion;delete group.dataset.hanTabsReady},{signal});
  })
}
initialiseHanHeroes();document.addEventListener('shopify:section:load',event=>initialiseHanHeroes(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["han-source-editorial"] && !Shopify.designMode) return;
  try {
    

function initHanSource(root = document) {
  const sections = [...root.querySelectorAll('.han-source')];
  if (root.matches?.('.han-source')) sections.unshift(root);
  sections.forEach(section => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const tabs = [...section.querySelectorAll('[data-han-usp-tab]')];
    const stage = section.querySelector('[data-han-usp-stage]');
    const panel = section.querySelector('[data-han-usp-panel]');
    const mobile = window.matchMedia('(max-width: 749px)');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let current;
    let inView = false;
    function syncVideo() {
      const video = stage?.querySelector('[data-han-usp-video]');
      if (!video) return;
      const src = mobile.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
      if (src && video.getAttribute('src') !== src) { video.src = src; video.load(); }
      video.controls = reduced.matches;
      if (reduced.matches || !inView) video.pause();
      else video.play().catch(() => { video.controls = true; });
    }
    function select(tab) {
      if (!tab || current === tab) return;
      current = tab;
      tabs.forEach(t => {
        const active = t === tab;
        t.classList.toggle('active', active);
        t.setAttribute('aria-selected', String(active));
        t.tabIndex = active ? 0 : -1;
      });
      const id = CSS.escape(tab.dataset.hanUspTab);
      const media = section.querySelector(`template[data-han-usp-media="${id}"]`);
      const copy = section.querySelector(`template[data-han-usp-copy="${id}"]`);
      stage?.querySelectorAll('video').forEach(video => video.pause());
      if (stage && media) { stage.replaceChildren(media.content.cloneNode(true)); stage.classList.toggle('han-usp-native', !stage.querySelector('.han-usp-ergonomic-art')); }
      if (panel && copy) { panel.querySelector('[data-han-usp-description]').replaceChildren(copy.content.cloneNode(true)); panel.setAttribute('aria-labelledby', tab.id); }
      syncVideo();
    }
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch' && matchMedia('(hover:hover) and (pointer:fine)').matches) select(tab); });
      tab.addEventListener('focus', () => select(tab));
      tab.addEventListener('keydown', event => {
        if (!['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const n = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (i + (['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1) + tabs.length) % tabs.length;
        select(tabs[n]); tabs[n].focus();
      });
    });
    const observer = stage ? new IntersectionObserver(entries => { inView = entries[0].isIntersecting; syncVideo(); }, {threshold: 0.05}) : null;
    if (stage) observer.observe(stage);
    mobile.addEventListener('change', syncVideo);
    reduced.addEventListener('change', syncVideo);
    section._hanUspCleanup = () => { observer?.disconnect(); mobile.removeEventListener('change', syncVideo); reduced.removeEventListener('change', syncVideo); stage?.querySelectorAll('video').forEach(video => video.pause()); };
    if (tabs.length) select(tabs[0]);
  });
}
initHanSource();
document.addEventListener('shopify:section:load', event => initHanSource(event.target));
document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.han-source').forEach(section => section._hanUspCleanup?.()));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerWrapper = document.querySelector('.header-wrapper');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBackgroundColorScheme = this.getAttribute('data-background-color-scheme');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      //this.throttledScrollHandler = throttle(this.onScrollHandler, 300);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      if (this.header) {
        observer.observe(this.header);
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
        this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-always-sticky');
        this.header.style.transform = 'translateY(-100%)';
      }

      if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
        this.header.classList.remove('color-background-2');
        this.header.style.transition = 'background var(--duration-short)';
        this.header.style.transform = 'translateY(0)';
      }

      if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
        this.header.classList.remove('shopify-section-header-sticky');
        this.header.style.transform = 'translateY(0)';
        this.header.style.transition = 'background var(--duration-short)';
        if (this.header.classList.contains(this.headerBackgroundColorScheme)) {
          this.header.classList.add('color-background-2');
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (document.querySelector('.overflow-hidden-tablet')) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      if (document.querySelector('.entering-section')) {
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      } else {
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden', 'color-background-2');
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      if (this.header.classList.contains(this.headerBackgroundColorScheme)) {
        this.header.classList.add('color-background-2');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      if (this.disclosures) {
        this.disclosures.forEach((disclosure) => {
          disclosure.close();
        });
      }
      this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
      if (this.disclosureLists) {
        this.disclosureLists.forEach((disclosureList) => {
          disclosureList.setAttribute('hidden', true);
        });
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  //class CartNote extends HTMLElement {
  //  constructor() {
  //    super();

  //    this.addEventListener(
  //      'change',
  //      debounce((event) => {
  //        const body = JSON.stringify({ note: event.target.value });
  //        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
  //      }, 300)
  //    );
  //  }
  //}

  //customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();

      this.isProductPage = true;
      this.visibleMediaObserver = null;
      this.visibleMediaRatios = new Map();
      this.activeVisibleMedia = null;
    }

    hide() {
      this.teardownVisibleMediaAutoplay();
      super.hide(this.isProductPage);
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
      this.setupVisibleMediaAutoplay();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      if (activeMedia) {
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
      }
      if (
        activeMedia?.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia?.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }

    isVideoAutoplayEnabled() {
      return this.dataset.enableVideoAutoplay === 'true';
    }

    setupVisibleMediaAutoplay() {
      this.teardownVisibleMediaAutoplay();

      if (!this.isVideoAutoplayEnabled()) return;

      const dialog = this.querySelector('.product-media-modal__dialog');
      const mediaItems = Array.from(this.querySelectorAll('.product-media-modal__item')).filter((item) =>
        item.querySelector('deferred-media')
      );

      if (!dialog || !mediaItems.length) return;

      this.visibleMediaObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.visibleMediaRatios.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0);
          });

          this.syncVisibleMediaPlayback();
        },
        {
          root: dialog,
          threshold: [0, 0.35, 0.6, 0.85],
        }
      );

      mediaItems.forEach((item) => {
        this.visibleMediaRatios.set(item, 0);
        this.visibleMediaObserver.observe(item);
      });

      requestAnimationFrame(() => this.syncVisibleMediaPlayback());
    }

    syncVisibleMediaPlayback() {
      if (!this.isVideoAutoplayEnabled()) return;

      let nextActiveMedia = null;
      let maxRatio = 0;

      this.visibleMediaRatios.forEach((ratio, item) => {
        if (ratio > maxRatio) {
          maxRatio = ratio;
          nextActiveMedia = item;
        }
      });

      if (maxRatio < 0.35) {
        nextActiveMedia = null;
      }

      if (this.activeVisibleMedia === nextActiveMedia) return;

      window.pauseAllMedia();
      this.activeVisibleMedia = nextActiveMedia;

      if (!nextActiveMedia) return;

      const deferredMedia = nextActiveMedia.querySelector('deferred-media');
      if (deferredMedia) {
        window.playMedia(deferredMedia);
      }
    }

    teardownVisibleMediaAutoplay() {
      this.visibleMediaObserver?.disconnect();
      this.visibleMediaObserver = null;
      this.visibleMediaRatios.clear();
      this.activeVisibleMedia = null;
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
